export const AppConfig = {
    pagination_size: 10,
};
